// extracted by mini-css-extract-plugin
export var container = "_2s-0";
export var disabled = "_2s-3";
export var enabled = "_2s-2";
export var statusLight = "_2s-1";